import React from 'react'

import TextField from 'components_new/atoms/TextField'
import { useTranslation } from 'language/translator'

interface EditVariableSectionProps {
  editName: string
  isDuplicate: boolean
  setEditName: (value: string) => void
}

const EditVariableSection = (props: EditVariableSectionProps) => {
  const { editName, isDuplicate, setEditName } = props

  const { t } = useTranslation()

  return (
    <TextField
      label={t('global', 'name')}
      value={editName}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setEditName(event.target.value)
      }}
      error={isDuplicate}
      helperText={
        isDuplicate
          ? t('accounting', 'account_level_name_exists_error')
          : undefined
      }
    />
  )
}

export default EditVariableSection
